import projectsHero from "../images/projects_hero.svg";
import ssoImage from "../images/projects/sso.png";
import BaseGImageCustomers from "../images/projects/10BaseG_Customers.png";
import BaseGImageContacts from "../images/projects/10BaseG_Contacts.png";
import azureMLImage from "../images/projects/AzureML.png";

export const Projects = () => {
  return (
    <>
      <div className="pageHero">
        <div className="pageHeroText">
          <h1 className="pageHeroTitle">Projects</h1>
          <p className="pageHeroSubtitle">
            Real-world solutions we have delivered — from identity management and
            custom CRM platforms to cutting-edge AI and machine learning deployments.
          </p>
        </div>
        <div className="pageHeroImageWrap hide-on-mobile">
          <img src={projectsHero} alt="Projects showcase" className="pageHeroImg" />
        </div>
      </div>

      <div className="pageContent">

        <div className="serviceSection">
          <h3 className="sectionTitle" style={{ display: "block", textAlign: "center", borderBottom: "none", paddingBottom: 0 }}>AI-Enhanced Projects</h3>
          <p style={{ maxWidth: "700px", margin: "4px auto 28px", textAlign: "center" }}>
            Every new engagement incorporates AI-driven capabilities to accelerate
            delivery and amplify business outcomes.
          </p>
          <div className="aiCardsRow">
            <div className="aiFeatureCard">
              <h6>Intelligent Identity Verification</h6>
              <p>
                Layer AI-powered anomaly detection and behavioral analytics on top
                of existing identity infrastructure to flag suspicious logins and
                prevent account takeover in real time.
              </p>
            </div>
            <div className="aiFeatureCard">
              <h6>AI-Augmented CRM</h6>
              <p>
                Embed predictive lead scoring, churn risk detection, and natural
                language summaries directly into CRM workflows so your team focuses
                on the highest-value opportunities.
              </p>
            </div>
            <div className="aiFeatureCard">
              <h6>Automated ML Pipelines</h6>
              <p>
                End-to-end MLOps on Azure — automated retraining, drift detection,
                model versioning, and one-click deployment so your models stay
                accurate as data evolves.
              </p>
            </div>
            <div className="aiFeatureCard">
              <h6>Predictive Analytics Dashboards</h6>
              <p>
                Real-time dashboards that blend historical data with forward-looking
                AI forecasts, giving decision-makers actionable intelligence at a glance.
              </p>
            </div>
          </div>
        </div>

        <div className="sectionDivider" />

        <div className="serviceSection">
          <div className="projectCard">
            <h4>Single Sign-On Solution</h4>
            <p>
              Simplify your login experience with Azure B2C. We design and implement
              single sign-on across multiple applications so your users authenticate
              once and access everything they need, with full support for external
              identity providers including Google, Facebook, LinkedIn, Active
              Directory, and Azure Active Directory.
            </p>
            <div className="projectScreenshots">
              <img src={ssoImage} alt="Single Sign-On Solution" />
            </div>
          </div>
        </div>

        <div className="sectionDivider" />

        <div className="serviceSection">
          <div className="projectCard">
            <h4>Customer Management &amp; Tracking</h4>
            <p>
              Build stronger customer relationships with a tailored CRM platform.
              Our custom 10BaseG solution gives your team a single view of every
              customer — contacts, history, interactions, and opportunities — so
              you can act on insights faster, improve satisfaction, and grow revenue.
            </p>
            <div className="projectScreenshots">
              <img src={BaseGImageCustomers} alt="Customer management dashboard" />
              <img src={BaseGImageContacts} alt="Contact management dashboard" />
            </div>
          </div>
        </div>

        <div className="sectionDivider" />

        <div className="serviceSection">
          <div className="projectCard">
            <h4>Azure Machine Learning</h4>
            <p>
              We leverage Azure Machine Learning to build, train, and deploy
              predictive models in the cloud. From data preparation and feature
              engineering through model evaluation and production deployment,
              we help data scientists and developers deliver ML solutions
              faster and more reliably.
            </p>
            <div className="projectScreenshots">
              <img src={azureMLImage} alt="Azure Machine Learning pipeline" />
            </div>
          </div>
        </div>

      </div>
    </>
  );
};
